import 'intersection-observer'
import loadJS from 'fg-loadjs'
import styles from './../config/map-styles'

window.loadMap = (apiKey) => {
    if ( !location || !apiKey ) {
        return
    }

    const map = document.getElementById('map')

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if ( entry.isIntersecting || entry.intersectionRatio > 0 ) {
                loadJS(`https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`)
                observer.unobserve(map)
            }
        })
    })

    observer.observe(map)
}

window.initMap = () => {
    var map = new google.maps.Map(document.getElementById('map'), {
        center: window.MAP_LOCATION,
        zoom: 15,
        styles: styles
    })

    var marker = new google.maps.Marker({
        map: map,
        position: window.MAP_LOCATION,
        title: 'Pall Mall Barbers'
    })
}
